const productList = () => import("@/pages/product/list/index.vue");
const productForm = () => import("@/pages/product/list/form.vue");

export default [
    {
        path: "/product/list",
        component: productList,
        meta: [
            {
                name: "产品管理",
                activeRoute: "/product/manage",
            },
            {
                name: "产品列表",
                activeRoute: "/product/list",
            },
        ],
    },
    {
        path: "/product/list/form",
        component: productForm,
        meta: [
            {
                name: "产品管理",
                activeRoute: "/product/manage",
            },
            {
                name: "产品列表",
                url: "/product/list",
            },
            {
                name: "新增/编辑商品",
                activeRoute: "/product/list",
            },
        ],
    },
];
